import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';

export enum UserProductStatuses {
	Active = 'active',
	Expired = 'expired',
	PastDue = 'past_due',
	Open = 'open',
	Scheduled = 'scheduled',
}

export interface UserProduct extends Dateable, AllowedActionable {
	id: number;
	userId: number;
	productId: number;
	orderID: number;
	validUntil: number;
	status: string;
	stripeStatus: string;
	productPriceId: number;

	order: models.order.Order;
	user: models.user.User;
	product: models.product.Product;
	productPrice: models.productPrice.ProductPrice;
}
